export default "__VITE_ASSET__DuuIbe15__"